import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Skeleton } from '@/ui';
import { ICategoryCommission } from '@/models/commission.model';
import CommissionCategoryItem from './CommissionCategoryItem';
import {
  StyledCategorySection,
  StyledHistoryFooterIcon,
  StyledHistoryFooterNote,
  StyledHistoryFooterText,
  StyledListWrapper,
  StyledTreeHeader,
  StyledTreeList,
} from '../CommissionList/CommissionListStyles';

type TCommissionCategoryTree = {
  categories: ICategoryCommission[];
  editedValues: Record<string, number>;
  onCommissionChange: (categoryId: string, value: number | null) => void;
  canManage: boolean;
  isLoading: boolean;
  selectedId: string | null;
  forcedOpenIds: Set<string>;
  onSelect: (categoryId: string) => void;
};

const CommissionCategoryTree = ({
  categories,
  editedValues,
  onCommissionChange,
  canManage,
  isLoading,
  selectedId,
  forcedOpenIds,
  onSelect,
}: TCommissionCategoryTree) => {
  const { t } = useTranslation(['commission']);

  if (isLoading) {
    return (
      <StyledListWrapper>
        <Skeleton active />
      </StyledListWrapper>
    );
  }

  return (
    <StyledListWrapper>
      <StyledTreeHeader>
        <span>{t('category_column')}</span>
        <span>{t('commission_column')}</span>
      </StyledTreeHeader>

      <StyledTreeList>
        {categories.map((category) => (
          <StyledCategorySection key={category.id}>
            <CommissionCategoryItem
              category={category}
              level={0}
              editedValues={editedValues}
              onCommissionChange={onCommissionChange}
              canManage={canManage}
              selectedId={selectedId}
              forcedOpenIds={forcedOpenIds}
              onSelect={onSelect}
            />
          </StyledCategorySection>
        ))}
      </StyledTreeList>

      <StyledHistoryFooterNote>
        <StyledHistoryFooterIcon>
          <InfoCircleOutlined />
        </StyledHistoryFooterIcon>
        <StyledHistoryFooterText>{t('categories_footer_note')}</StyledHistoryFooterText>
      </StyledHistoryFooterNote>
    </StyledListWrapper>
  );
};

export default CommissionCategoryTree;
